import React, { useEffect, useState } from "react";
import "../detailNewspage/styles/index.less";
import { Typography, Layout, Result, Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { user_create_login } from "../../services/user";

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

type Props = {};

const ConfirmPage = (props: Props) => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      try {
        const decoded = jwtDecode(id);
        handleCreateUser(decoded);
      } catch (error) {
        // console.error('Invalid JWT token:', error);
      }
    }
  }, [id]);

  const handleCreateUser = async (decodedData: any) => {
    try {
      const res = await user_create_login({
        email: decodedData.email,
      });

      if (res.message === "success") {
      } else {
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#F3F3F1",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="sign-up-container">
        <Result
          style={{ borderColor: "#000", padding: "120px 60px" }}
          status="success"
          title="You account has been verified successfully"
          subTitle={
            <span style={{ fontSize: "18px" }}>
              Thank you for trust, You can now Login to access our features.
            </span>
          }
          extra={[
            <Button
              size="large"
              key="console"
              style={{ backgroundColor: "#00215E", borderColor: "#00215E", borderRadius: 8 , color:"#ffffff" }}
              onClick={async () => {
                navigate("/");
              }}
            >
              Home page
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default ConfirmPage;
